import React from "react"
import clsx from "clsx"
import { observer } from "mobx-react-lite"

import Icon from "@components/ui/Icon/Icon"
import Text from "@components/ui/Typography/Text"
import { WorkbookSuggestionOption } from "@store/search/types"
import { getReportDescriptionByType } from "@framework/constants/workbook"
import { renderWorkflowQuery } from "@utils/workflow-report"

import styles from "./ReportSuggestionCard.module.sass"

export interface ReportSuggestionCardProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  option: WorkbookSuggestionOption
  disabled?: boolean
  slim?: boolean
}

const ReportSuggestionCard: React.FC<ReportSuggestionCardProps> = observer(
  ({ option, disabled = false, slim = false, className, ...rest }) => {
    const workflowDesc = getReportDescriptionByType(option.type)
    return (
      <button
        type="button"
        className={clsx(styles.root, { [styles.slim]: slim }, className)}
        disabled={disabled}
        {...rest}
      >
        <Icon name={workflowDesc.icon} className={styles.titleIcon} />
        <Text
          color="inherit"
          variant="body3"
          align="start"
          className={styles.body}
        >
          {renderWorkflowQuery(workflowDesc.type, option.data) ||
            workflowDesc.message}
        </Text>
        <Icon name="arrow-up" rotateAngle={90} className={styles.runIcon} />
      </button>
    )
  }
)

export default ReportSuggestionCard
